export default {
  namespaced: true,
  state: {
    loginMobile: '',
    isOpenLogin: false,
  },
  mutations: {
    setLoginMobile(state, payload) {
      state.loginMobile = payload
    },
    setIsOpenLogin(state, payload) {
      state.isOpenLogin = payload
    },
  },
  actions: {
    async checkLogin({ state, commit }, payload = {}) {
      const { open = true } = payload
      const { loginMobile } = state
      if (loginMobile) {
        return true
      } else {
        if (open) {
          commit('setIsOpenLogin', true)
        }
        return false
      }
    },
  },
}
